/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AddressBaseDto } from '../models/address-base-dto';
import { AddressRo } from '../models/address-ro';
import { AllContractsBaseDto } from '../models/all-contracts-base-dto';
import { BaseRequestDto } from '../models/base-request-dto';
import { ContracBaseDto } from '../models/contrac-base-dto';
import { CreateContractRo } from '../models/create-contract-ro';
import { CreateInfrastructureDto } from '../models/create-infrastructure-dto';
import { CreateJobDto } from '../models/create-job-dto';
import { CreateOrganizationDto } from '../models/create-organization-dto';
import { CreateOrganizationRo } from '../models/create-organization-ro';
import { CreatePermissionDto } from '../models/create-permission-dto';
import { CreateProjectDto } from '../models/create-project-dto';
import { CreateProjectMemberDto } from '../models/create-project-member-dto';
import { CreateResourceDto } from '../models/create-resource-dto';
import { CreatedUserDto } from '../models/created-user-dto';
import { GetProjectDto } from '../models/get-project-dto';
import { GetAllInfrastructuresDto } from '../models/get-all-infrastructures-dto';
import { GetInfrastructureDto } from '../models/get-infrastructure-dto';
import { GetOrganizationDto } from '../models/get-organization-dto';
import { GetOrganizationLoclisationSettingsDto } from '../models/get-organization-loclisation-settings-dto';
import { GetOrganizationSettingsBodyDto } from '../models/get-organization-settings-body-dto';
import { GetResourceRateDto } from '../models/get-resource-rate-dto';
import { GetResourceSettingsDto } from '../models/get-resource-settings-dto';
import { GetResourcesBodyDto } from '../models/get-resources-body-dto';
import { GroupDto } from '../models/group-dto';
import { GroupRo } from '../models/group-ro';
import { InfrastructureListRequestDto } from '../models/infrastructure-list-request-dto';
import { InfrastructureRo } from '../models/infrastructure-ro';
import { InfrastructureResourcesRequestDto } from '../models/infrastructure-resources-request-dto';
import { InviteUserDto } from '../models/invite-user-dto';
import { JobRo } from '../models/job-ro';
import { MemberProfileBodyDto } from '../models/member-profile-body-dto';
import { MemberRo } from '../models/member-ro';
import { OrganizationAccessSettingsRo } from '../models/organization-access-settings-ro';
import { OrganizationDto } from '../models/organization-dto';
import { OrganizationInvoicesSettingsRo } from '../models/organization-invoices-settings-ro';
import { OrganizationMemberSettingsRo } from '../models/organization-member-settings-ro';
import { OrganizationMembersDto } from '../models/organization-members-dto';
import { OrganizationReservationSettingsRo } from '../models/organization-reservation-settings-ro';
import { OrganizationlocalisationSettingsRo } from '../models/organizationlocalisation-settings-ro';
import { PermissionGetAllDto } from '../models/permission-get-all-dto';
import { PhoneDto } from '../models/phone-dto';
import { PhoneRo } from '../models/phone-ro';
import { ProjectGetDto } from '../models/project-get-dto';
import { ProjectListRequestDto } from '../models/project-list-request-dto';
import { ProjectMemberRequestDto } from '../models/project-member-request-dto';
import { ProjectMemberRo } from '../models/project-member-ro';
import { ProjectRo } from '../models/project-ro';
import { RegisterUserFromTokenDto } from '../models/register-user-from-token-dto';
import { ReservationCreateDto } from '../models/reservation-create-dto';
import { ReservationRo } from '../models/reservation-ro';
import { ReservationsDto } from '../models/reservations-dto';
import { ResetPasswordDto } from '../models/reset-password-dto';
import { ResetPasswordRo } from '../models/reset-password-ro';
import { ResourceGetDto } from '../models/resource-get-dto';
import { ResourceRo } from '../models/resource-ro';
import { ResourceRateRo } from '../models/resource-rate-ro';
import { ResourceReservationVisibilityRo } from '../models/resource-reservation-visibility-ro';
import { ResourceSettingsGeneralPropertiesRo } from '../models/resource-settings-general-properties-ro';
import { ResourceSettingsGeneralStatusRo } from '../models/resource-settings-general-status-ro';
import { ResourceSettingsGeneralVisibilityRo } from '../models/resource-settings-general-visibility-ro';
import { ResourceTimerRestrictionRo } from '../models/resource-timer-restriction-ro';
import { ResourcesGetDto } from '../models/resources-get-dto';
import { ResourcesSettingsReservationGeneralRo } from '../models/resources-settings-reservation-general-ro';
import { ResourcesSettingsReservationUnitRo } from '../models/resources-settings-reservation-unit-ro';
import { SwitchedMemberDto } from '../models/switched-member-dto';
import { UpdateContracBaseDto } from '../models/update-contrac-base-dto';
import { UpdateContractRo } from '../models/update-contract-ro';
import { UpdateInfrastructureDto } from '../models/update-infrastructure-dto';
import { UpdateMemberDto } from '../models/update-member-dto';
import { UpdateOrganizationDto } from '../models/update-organization-dto';
import { UpdateOrganizationRo } from '../models/update-organization-ro';
import { UpdateOrganizationSettingsDto } from '../models/update-organization-settings-dto';
import { UpdatePermissionDto } from '../models/update-permission-dto';
import { UpdateProjectDto } from '../models/update-project-dto';
import { UpdateProjectMemberDto } from '../models/update-project-member-dto';
import { UpdateProjectParticipantRo } from '../models/update-project-participant-ro';
import { UpdateProjectRo } from '../models/update-project-ro';
import { UpdateResourceDto } from '../models/update-resource-dto';
import { UpdateResourceRo } from '../models/update-resource-ro';
import { UpdateinfrastructureRo } from '../models/updateinfrastructure-ro';
import { UserGetDto } from '../models/user-get-dto';
import { UserIdDto } from '../models/user-id-dto';
import { UserInviteToOrgRo } from '../models/user-invite-to-org-ro';
import { UserRo } from '../models/user-ro';
import { UserResendPassword } from '../models/user-resend-password';
import { ChangeUserLanguageDto } from '../models/change-user-language-dto';
import { CreatePermissionRo } from '../models/create-permission-ro';
import { GetMembershipDto } from '../models/get-membership-dto';
import { PermissionGetDto } from '../models/permission-get-dto';
import { ResourceManagersRequestDto } from '../models/resource-managers-request-dto';
import { SubInfraListRequestDto } from '../models/sub-infra-list-request-dto';
import { UpdatePermissionRo } from '../models/update-permission-ro';

@Injectable({
  providedIn: 'root',
})
export class ApiService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation addressRoutesGetById
   */
  static readonly AddressRoutesGetByIdPath = '/address/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.AddressRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addressRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.addressRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation addressRoutesGetAll
   */
  static readonly AddressRoutesGetAllPath = '/address/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.AddressRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addressRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesGetAll(params?: {
  }): Observable<void> {

    return this.addressRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation addressRoutesUpdate
   */
  static readonly AddressRoutesUpdatePath = '/address/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.AddressRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addressRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addressRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.addressRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation addressRoutesRemove
   */
  static readonly AddressRoutesRemovePath = '/address/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addressRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.AddressRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `addressRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  addressRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.addressRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation jobRoutesCreateJob
   */
  static readonly JobRoutesCreateJobPath = '/jobs/create';

  /**
   * create a job that the organization offer
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesCreateJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesCreateJob$Response(params: {
    body: JobRo
  }): Observable<StrictHttpResponse<CreateJobDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesCreateJobPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateJobDto>;
      })
    );
  }

  /**
   * create a job that the organization offer
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesCreateJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesCreateJob(params: {
    body: JobRo
  }): Observable<CreateJobDto> {

    return this.jobRoutesCreateJob$Response(params).pipe(
      map((r: StrictHttpResponse<CreateJobDto>) => r.body as CreateJobDto)
    );
  }

  /**
   * Path part for operation jobRoutesUpdateJob
   */
  static readonly JobRoutesUpdateJobPath = '/jobs/update/{id}';

  /**
   * update a job data given its id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesUpdateJob()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesUpdateJob$Response(params: {
    id: number;
    body: JobRo
  }): Observable<StrictHttpResponse<CreateJobDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesUpdateJobPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateJobDto>;
      })
    );
  }

  /**
   * update a job data given its id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesUpdateJob$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesUpdateJob(params: {
    id: number;
    body: JobRo
  }): Observable<CreateJobDto> {

    return this.jobRoutesUpdateJob$Response(params).pipe(
      map((r: StrictHttpResponse<CreateJobDto>) => r.body as CreateJobDto)
    );
  }

  /**
   * Path part for operation jobRoutesGetById
   */
  static readonly JobRoutesGetByIdPath = '/jobs/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.jobRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation jobRoutesGetAll
   */
  static readonly JobRoutesGetAllPath = '/jobs/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesGetAll(params?: {
  }): Observable<void> {

    return this.jobRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation jobRoutesUpdate
   */
  static readonly JobRoutesUpdatePath = '/jobs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  jobRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.jobRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation jobRoutesRemove
   */
  static readonly JobRoutesRemovePath = '/jobs/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `jobRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.JobRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `jobRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  jobRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.jobRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation memberRoutesInviteUserToOrganization
   */
  static readonly MemberRoutesInviteUserToOrganizationPath = '/members/inviteUserToOrganization';

  /**
   * invite a user to an organization
   * creates the newly invited user in keycloak
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesInviteUserToOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesInviteUserToOrganization$Response(params: {
    body: UserInviteToOrgRo
  }): Observable<StrictHttpResponse<InviteUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesInviteUserToOrganizationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InviteUserDto>;
      })
    );
  }

  /**
   * invite a user to an organization
   * creates the newly invited user in keycloak
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesInviteUserToOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesInviteUserToOrganization(params: {
    body: UserInviteToOrgRo
  }): Observable<InviteUserDto> {

    return this.memberRoutesInviteUserToOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<InviteUserDto>) => r.body as InviteUserDto)
    );
  }

  /**
   * Path part for operation memberRoutesResendInvite
   */
  static readonly MemberRoutesResendInvitePath = '/members/resendInvite';

  /**
   * resend the reset password email to the invited user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesResendInvite()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesResendInvite$Response(params: {
    body: UserResendPassword
  }): Observable<StrictHttpResponse<UserIdDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesResendInvitePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserIdDto>;
      })
    );
  }

  /**
   * resend the reset password email to the invited user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesResendInvite$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesResendInvite(params: {
    body: UserResendPassword
  }): Observable<UserIdDto> {

    return this.memberRoutesResendInvite$Response(params).pipe(
      map((r: StrictHttpResponse<UserIdDto>) => r.body as UserIdDto)
    );
  }

  /**
   * Path part for operation memberRoutesSwitchOrganization
   */
  static readonly MemberRoutesSwitchOrganizationPath = '/members/switchOrganization/{orgId}';

  /**
   * update the current_org
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesSwitchOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesSwitchOrganization$Response(params: {

    /**
     * id of the organization to switch to
     */
    orgId: number;
  }): Observable<StrictHttpResponse<SwitchedMemberDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesSwitchOrganizationPath, 'put');
    if (params) {
      rb.path('orgId', params.orgId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SwitchedMemberDto>;
      })
    );
  }

  /**
   * update the current_org
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesSwitchOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesSwitchOrganization(params: {

    /**
     * id of the organization to switch to
     */
    orgId: number;
  }): Observable<SwitchedMemberDto> {

    return this.memberRoutesSwitchOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<SwitchedMemberDto>) => r.body as SwitchedMemberDto)
    );
  }

  /**
   * Path part for operation memberRoutesUpdateMembershipStatus
   */
  static readonly MemberRoutesUpdateMembershipStatusPath = '/members/{userId}/{orgId}/membership';

  /**
   * /**
   *   Update a Membership status in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesUpdateMembershipStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdateMembershipStatus$Response(params: {
    userId: number;
    orgId: number;

    /**
     * Should contain Resource data that include Resource data with its id
     */
    body: MemberRo
  }): Observable<StrictHttpResponse<UpdateMemberDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesUpdateMembershipStatusPath, 'put');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('orgId', params.orgId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateMemberDto>;
      })
    );
  }

  /**
   * /**
   *   Update a Membership status in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesUpdateMembershipStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdateMembershipStatus(params: {
    userId: number;
    orgId: number;

    /**
     * Should contain Resource data that include Resource data with its id
     */
    body: MemberRo
  }): Observable<UpdateMemberDto> {

    return this.memberRoutesUpdateMembershipStatus$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateMemberDto>) => r.body as UpdateMemberDto)
    );
  }

  /**
   * Path part for operation memberRoutesGetUserMemberships
   */
  static readonly MemberRoutesGetUserMembershipsPath = '/members/{userId}/memberships';

  /**
   * get all user memberships
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesGetUserMemberships()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetUserMemberships$Response(params: {

    /**
     * userId
     */
    userId: number;
  }): Observable<StrictHttpResponse<GetMembershipDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesGetUserMembershipsPath, 'get');
    if (params) {
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetMembershipDto>;
      })
    );
  }

  /**
   * get all user memberships
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesGetUserMemberships$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetUserMemberships(params: {

    /**
     * userId
     */
    userId: number;
  }): Observable<GetMembershipDto> {

    return this.memberRoutesGetUserMemberships$Response(params).pipe(
      map((r: StrictHttpResponse<GetMembershipDto>) => r.body as GetMembershipDto)
    );
  }

  /**
   * Path part for operation memberRoutesGetMemberProfile
   */
  static readonly MemberRoutesGetMemberProfilePath = '/members/getMemberProfile/{orgId}/{userId}';

  /**
   * get a member profile details
   * the member is identified with an organization id and a user id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesGetMemberProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetMemberProfile$Response(params: {

    /**
     * organization that the member belongs to
     */
    orgId: number;

    /**
     * that the member refers to
     */
    userId: number;
  }): Observable<StrictHttpResponse<MemberProfileBodyDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesGetMemberProfilePath, 'get');
    if (params) {
      rb.path('orgId', params.orgId, {});
      rb.path('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MemberProfileBodyDto>;
      })
    );
  }

  /**
   * get a member profile details
   * the member is identified with an organization id and a user id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesGetMemberProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetMemberProfile(params: {

    /**
     * organization that the member belongs to
     */
    orgId: number;

    /**
     * that the member refers to
     */
    userId: number;
  }): Observable<MemberProfileBodyDto> {

    return this.memberRoutesGetMemberProfile$Response(params).pipe(
      map((r: StrictHttpResponse<MemberProfileBodyDto>) => r.body as MemberProfileBodyDto)
    );
  }

  /**
   * Path part for operation memberRoutesUpdateMember
   */
  static readonly MemberRoutesUpdateMemberPath = '/members/{orgId}/{userId}';

  /**
   * override the base update
   * since the member is identified with a userId and an organizationId
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesUpdateMember()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdateMember$Response(params: {

    /**
     * organization that the member belongs to
     */
    orgId: number;

    /**
     * that the member refers to
     */
    userId: number;
    body: MemberRo
  }): Observable<StrictHttpResponse<MemberProfileBodyDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesUpdateMemberPath, 'put');
    if (params) {
      rb.path('orgId', params.orgId, {});
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MemberProfileBodyDto>;
      })
    );
  }

  /**
   * override the base update
   * since the member is identified with a userId and an organizationId
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesUpdateMember$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdateMember(params: {

    /**
     * organization that the member belongs to
     */
    orgId: number;

    /**
     * that the member refers to
     */
    userId: number;
    body: MemberRo
  }): Observable<MemberProfileBodyDto> {

    return this.memberRoutesUpdateMember$Response(params).pipe(
      map((r: StrictHttpResponse<MemberProfileBodyDto>) => r.body as MemberProfileBodyDto)
    );
  }

  /**
   * Path part for operation memberRoutesGetById
   */
  static readonly MemberRoutesGetByIdPath = '/members/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.memberRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation memberRoutesGetAll
   */
  static readonly MemberRoutesGetAllPath = '/members/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesGetAll(params?: {
  }): Observable<void> {

    return this.memberRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation memberRoutesUpdate
   */
  static readonly MemberRoutesUpdatePath = '/members/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  memberRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.memberRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation memberRoutesRemove
   */
  static readonly MemberRoutesRemovePath = '/members/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `memberRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.MemberRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `memberRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  memberRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.memberRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation contractRoutesGetAllMemberContracts
   */
  static readonly ContractRoutesGetAllMemberContractsPath = '/contracts/{orgId}/{userId}';

  /**
   * Retrieve all member contracts
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesGetAllMemberContracts()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetAllMemberContracts$Response(params: {

    /**
     * of organization id
     */
    orgId: number;

    /**
     * of user id
     */
    userId: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<AllContractsBaseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesGetAllMemberContractsPath, 'get');
    if (params) {
      rb.path('orgId', params.orgId, {});
      rb.path('userId', params.userId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AllContractsBaseDto>;
      })
    );
  }

  /**
   * Retrieve all member contracts
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesGetAllMemberContracts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetAllMemberContracts(params: {

    /**
     * of organization id
     */
    orgId: number;

    /**
     * of user id
     */
    userId: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<AllContractsBaseDto> {

    return this.contractRoutesGetAllMemberContracts$Response(params).pipe(
      map((r: StrictHttpResponse<AllContractsBaseDto>) => r.body as AllContractsBaseDto)
    );
  }

  /**
   * Path part for operation contractRoutesCreateContract
   */
  static readonly ContractRoutesCreateContractPath = '/contracts/create';

  /**
   * Override the create method
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesCreateContract()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesCreateContract$Response(params: {
    body: CreateContractRo
  }): Observable<StrictHttpResponse<ContracBaseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesCreateContractPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContracBaseDto>;
      })
    );
  }

  /**
   * Override the create method
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesCreateContract$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesCreateContract(params: {
    body: CreateContractRo
  }): Observable<ContracBaseDto> {

    return this.contractRoutesCreateContract$Response(params).pipe(
      map((r: StrictHttpResponse<ContracBaseDto>) => r.body as ContracBaseDto)
    );
  }

  /**
   * Path part for operation contractRoutesCreateUpdateContract
   */
  static readonly ContractRoutesCreateUpdateContractPath = '/contracts/update/{id}';

  /**
   * Override the update method
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesCreateUpdateContract()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesCreateUpdateContract$Response(params: {

    /**
     * of updated contract
     */
    id: number;

    /**
     * updated properties
     */
    body: UpdateContractRo
  }): Observable<StrictHttpResponse<UpdateContracBaseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesCreateUpdateContractPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateContracBaseDto>;
      })
    );
  }

  /**
   * Override the update method
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesCreateUpdateContract$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesCreateUpdateContract(params: {

    /**
     * of updated contract
     */
    id: number;

    /**
     * updated properties
     */
    body: UpdateContractRo
  }): Observable<UpdateContracBaseDto> {

    return this.contractRoutesCreateUpdateContract$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateContracBaseDto>) => r.body as UpdateContracBaseDto)
    );
  }

  /**
   * Path part for operation contractRoutesGetById
   */
  static readonly ContractRoutesGetByIdPath = '/contracts/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.contractRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation contractRoutesGetAll
   */
  static readonly ContractRoutesGetAllPath = '/contracts/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesGetAll(params?: {
  }): Observable<void> {

    return this.contractRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation contractRoutesUpdate
   */
  static readonly ContractRoutesUpdatePath = '/contracts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contractRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.contractRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation contractRoutesRemove
   */
  static readonly ContractRoutesRemovePath = '/contracts/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contractRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ContractRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contractRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  contractRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.contractRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation groupRoutesGetOrganizationGroup
   */
  static readonly GroupRoutesGetOrganizationGroupPath = '/groups/getOrganizationGroup/{organizationId}';

  /**
   * get organization groups
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesGetOrganizationGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetOrganizationGroup$Response(params: {
    organizationId: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<GroupRo>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesGetOrganizationGroupPath, 'get');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupRo>;
      })
    );
  }

  /**
   * get organization groups
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesGetOrganizationGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetOrganizationGroup(params: {
    organizationId: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<GroupRo> {

    return this.groupRoutesGetOrganizationGroup$Response(params).pipe(
      map((r: StrictHttpResponse<GroupRo>) => r.body as GroupRo)
    );
  }

  /**
   * Path part for operation groupRoutesCreateGroup
   */
  static readonly GroupRoutesCreateGroupPath = '/groups/create';

  /**
   * create a group
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesCreateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesCreateGroup$Response(params: {
    body: GroupRo
  }): Observable<StrictHttpResponse<GroupDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesCreateGroupPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupDto>;
      })
    );
  }

  /**
   * create a group
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesCreateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesCreateGroup(params: {
    body: GroupRo
  }): Observable<GroupDto> {

    return this.groupRoutesCreateGroup$Response(params).pipe(
      map((r: StrictHttpResponse<GroupDto>) => r.body as GroupDto)
    );
  }

  /**
   * Path part for operation groupRoutesUpdateGroup
   */
  static readonly GroupRoutesUpdateGroupPath = '/groups/update/{id}';

  /**
   * update group by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesUpdateGroup()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesUpdateGroup$Response(params: {
    id: number;
    body: GroupRo
  }): Observable<StrictHttpResponse<GroupDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesUpdateGroupPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupDto>;
      })
    );
  }

  /**
   * update group by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesUpdateGroup$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesUpdateGroup(params: {
    id: number;
    body: GroupRo
  }): Observable<GroupDto> {

    return this.groupRoutesUpdateGroup$Response(params).pipe(
      map((r: StrictHttpResponse<GroupDto>) => r.body as GroupDto)
    );
  }

  /**
   * Path part for operation groupRoutesUpdateGroupMember
   */
  static readonly GroupRoutesUpdateGroupMemberPath = '/groups/groupMember/{groupId}/{userId}';

  /**
   * add group memebers by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesUpdateGroupMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesUpdateGroupMember$Response(params: {

    /**
     * the member user id
     */
    userId: number;

    /**
     * the group id
     */
    groupId: number;
  }): Observable<StrictHttpResponse<GroupDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesUpdateGroupMemberPath, 'post');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('groupId', params.groupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupDto>;
      })
    );
  }

  /**
   * add group memebers by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesUpdateGroupMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesUpdateGroupMember(params: {

    /**
     * the member user id
     */
    userId: number;

    /**
     * the group id
     */
    groupId: number;
  }): Observable<GroupDto> {

    return this.groupRoutesUpdateGroupMember$Response(params).pipe(
      map((r: StrictHttpResponse<GroupDto>) => r.body as GroupDto)
    );
  }

  /**
   * Path part for operation groupRoutesDeleteGroupMember
   */
  static readonly GroupRoutesDeleteGroupMemberPath = '/groups/groupMember/{groupId}/{userId}';

  /**
   * delete group memebers by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesDeleteGroupMember()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesDeleteGroupMember$Response(params: {

    /**
     * the member user id
     */
    userId: number;
    groupId: number;
  }): Observable<StrictHttpResponse<GroupDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesDeleteGroupMemberPath, 'delete');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.path('groupId', params.groupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupDto>;
      })
    );
  }

  /**
   * delete group memebers by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesDeleteGroupMember$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesDeleteGroupMember(params: {

    /**
     * the member user id
     */
    userId: number;
    groupId: number;
  }): Observable<GroupDto> {

    return this.groupRoutesDeleteGroupMember$Response(params).pipe(
      map((r: StrictHttpResponse<GroupDto>) => r.body as GroupDto)
    );
  }

  /**
   * Path part for operation groupRoutesDeleteGroup
   */
  static readonly GroupRoutesDeleteGroupPath = '/groups/delete/{id}';

  /**
   * delete group by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesDeleteGroup()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesDeleteGroup$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<GroupDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesDeleteGroupPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupDto>;
      })
    );
  }

  /**
   * delete group by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesDeleteGroup$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesDeleteGroup(params: {
    id: number;
  }): Observable<GroupDto> {

    return this.groupRoutesDeleteGroup$Response(params).pipe(
      map((r: StrictHttpResponse<GroupDto>) => r.body as GroupDto)
    );
  }

  /**
   * Path part for operation groupRoutesGetGroupMembers
   */
  static readonly GroupRoutesGetGroupMembersPath = '/groups/{groupId}/members';

  /**
   * get group members
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesGetGroupMembers()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetGroupMembers$Response(params: {
    groupId: number;
  }): Observable<StrictHttpResponse<GroupRo>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesGetGroupMembersPath, 'get');
    if (params) {
      rb.path('groupId', params.groupId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GroupRo>;
      })
    );
  }

  /**
   * get group members
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesGetGroupMembers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetGroupMembers(params: {
    groupId: number;
  }): Observable<GroupRo> {

    return this.groupRoutesGetGroupMembers$Response(params).pipe(
      map((r: StrictHttpResponse<GroupRo>) => r.body as GroupRo)
    );
  }

  /**
   * Path part for operation groupRoutesGetById
   */
  static readonly GroupRoutesGetByIdPath = '/groups/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.groupRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation groupRoutesGetAll
   */
  static readonly GroupRoutesGetAllPath = '/groups/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesGetAll(params?: {
  }): Observable<void> {

    return this.groupRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation groupRoutesUpdate
   */
  static readonly GroupRoutesUpdatePath = '/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  groupRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.groupRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation groupRoutesRemove
   */
  static readonly GroupRoutesRemovePath = '/groups/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `groupRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.GroupRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `groupRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  groupRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.groupRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation infrastructureRoutesCreateInfrastructure
   */
  static readonly InfrastructureRoutesCreateInfrastructurePath = '/infrastructure/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesCreateInfrastructure()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesCreateInfrastructure$Response(params: {

    /**
     * Should contain infrustructure data
     */
    body: InfrastructureRo
  }): Observable<StrictHttpResponse<CreateInfrastructureDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesCreateInfrastructurePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateInfrastructureDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesCreateInfrastructure$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesCreateInfrastructure(params: {

    /**
     * Should contain infrustructure data
     */
    body: InfrastructureRo
  }): Observable<CreateInfrastructureDto> {

    return this.infrastructureRoutesCreateInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<CreateInfrastructureDto>) => r.body as CreateInfrastructureDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesUpdateinfrastructure
   */
  static readonly InfrastructureRoutesUpdateinfrastructurePath = '/infrastructure/update/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesUpdateinfrastructure()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesUpdateinfrastructure$Response(params: {

    /**
     * id of the requested infrustructure
     */
    id: number;

    /**
     * Should contain infrustructure data that include infrustructure data with its id
     */
    body: UpdateinfrastructureRo
  }): Observable<StrictHttpResponse<UpdateInfrastructureDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesUpdateinfrastructurePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateInfrastructureDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesUpdateinfrastructure$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesUpdateinfrastructure(params: {

    /**
     * id of the requested infrustructure
     */
    id: number;

    /**
     * Should contain infrustructure data that include infrustructure data with its id
     */
    body: UpdateinfrastructureRo
  }): Observable<UpdateInfrastructureDto> {

    return this.infrastructureRoutesUpdateinfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateInfrastructureDto>) => r.body as UpdateInfrastructureDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetAllOrganizationInfrastructures
   */
  static readonly InfrastructureRoutesGetAllOrganizationInfrastructuresPath = '/infrastructure/getAll/{orgId}';

  /**
   * retrieve Organization infrustructures by organization id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetAllOrganizationInfrastructures()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllOrganizationInfrastructures$Response(params: {

    /**
     * organization id
     */
    orgId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;
  }): Observable<StrictHttpResponse<GetAllInfrastructuresDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetAllOrganizationInfrastructuresPath, 'get');
    if (params) {
      rb.path('orgId', params.orgId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAllInfrastructuresDto>;
      })
    );
  }

  /**
   * retrieve Organization infrustructures by organization id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetAllOrganizationInfrastructures$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllOrganizationInfrastructures(params: {

    /**
     * organization id
     */
    orgId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;
  }): Observable<GetAllInfrastructuresDto> {

    return this.infrastructureRoutesGetAllOrganizationInfrastructures$Response(params).pipe(
      map((r: StrictHttpResponse<GetAllInfrastructuresDto>) => r.body as GetAllInfrastructuresDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization
   */
  static readonly InfrastructureRoutesGetAllInfrastructuresOfAgivenOrganizationPath = '/infrastructure/getAllInfrastructuresOfAgivenOrganization/{orgId}';

  /**
   * get the list of infrastructure of a given organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization$Response(params: {

    /**
     * : organization id
     */
    orgId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<InfrastructureListRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetAllInfrastructuresOfAgivenOrganizationPath, 'get');
    if (params) {
      rb.path('orgId', params.orgId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfrastructureListRequestDto>;
      })
    );
  }

  /**
   * get the list of infrastructure of a given organization
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization(params: {

    /**
     * : organization id
     */
    orgId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<InfrastructureListRequestDto> {

    return this.infrastructureRoutesGetAllInfrastructuresOfAgivenOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<InfrastructureListRequestDto>) => r.body as InfrastructureListRequestDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesAddResourceToInfrastructure
   */
  static readonly InfrastructureRoutesAddResourceToInfrastructurePath = '/infrastructure/infraResources/{infrastructureId}/{resourceId}';

  /**
   * add a resource to a given infrastructure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesAddResourceToInfrastructure()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesAddResourceToInfrastructure$Response(params: {

    /**
     * : resource id
     */
    resourceId: number;

    /**
     * : infrastructure id
     */
    infrastructureId: number;
  }): Observable<StrictHttpResponse<GetInfrastructureDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesAddResourceToInfrastructurePath, 'post');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.path('infrastructureId', params.infrastructureId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetInfrastructureDto>;
      })
    );
  }

  /**
   * add a resource to a given infrastructure
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesAddResourceToInfrastructure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesAddResourceToInfrastructure(params: {

    /**
     * : resource id
     */
    resourceId: number;

    /**
     * : infrastructure id
     */
    infrastructureId: number;
  }): Observable<GetInfrastructureDto> {

    return this.infrastructureRoutesAddResourceToInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<GetInfrastructureDto>) => r.body as GetInfrastructureDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesDeleteResourceFromGivenInfrastructure
   */
  static readonly InfrastructureRoutesDeleteResourceFromGivenInfrastructurePath = '/infrastructure/infraResources/{infrastructureId}/{resourceId}';

  /**
   * delete a resource from a given infrastructure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesDeleteResourceFromGivenInfrastructure()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesDeleteResourceFromGivenInfrastructure$Response(params: {

    /**
     * : resource id
     */
    resourceId: number;

    /**
     * : infrastructure id
     */
    infrastructureId: number;
  }): Observable<StrictHttpResponse<GetInfrastructureDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesDeleteResourceFromGivenInfrastructurePath, 'delete');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.path('infrastructureId', params.infrastructureId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetInfrastructureDto>;
      })
    );
  }

  /**
   * delete a resource from a given infrastructure
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesDeleteResourceFromGivenInfrastructure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesDeleteResourceFromGivenInfrastructure(params: {

    /**
     * : resource id
     */
    resourceId: number;

    /**
     * : infrastructure id
     */
    infrastructureId: number;
  }): Observable<GetInfrastructureDto> {

    return this.infrastructureRoutesDeleteResourceFromGivenInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<GetInfrastructureDto>) => r.body as GetInfrastructureDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetInfrastructureById
   */
  static readonly InfrastructureRoutesGetInfrastructureByIdPath = '/infrastructure/{id}';

  /**
   * get an infastructure with a given Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetInfrastructureById()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetInfrastructureById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<InfrastructureListRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetInfrastructureByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfrastructureListRequestDto>;
      })
    );
  }

  /**
   * get an infastructure with a given Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetInfrastructureById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetInfrastructureById(params: {
    id: number;
  }): Observable<InfrastructureListRequestDto> {

    return this.infrastructureRoutesGetInfrastructureById$Response(params).pipe(
      map((r: StrictHttpResponse<InfrastructureListRequestDto>) => r.body as InfrastructureListRequestDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesUpdate
   */
  static readonly InfrastructureRoutesUpdatePath = '/infrastructure/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  infrastructureRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.infrastructureRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation infrastructureRoutesRemove
   */
  static readonly InfrastructureRoutesRemovePath = '/infrastructure/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.infrastructureRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure
   */
  static readonly InfrastructureRoutesGetAllRessourcesOfAgivenInfrastructurePath = '/infrastructure/{id}/resources';

  /**
   * get all resources of a given infrastructure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure$Response(params: {

    /**
     * : infrastructure id
     */
    id: number;
  }): Observable<StrictHttpResponse<InfrastructureResourcesRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetAllRessourcesOfAgivenInfrastructurePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<InfrastructureResourcesRequestDto>;
      })
    );
  }

  /**
   * get all resources of a given infrastructure
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure(params: {

    /**
     * : infrastructure id
     */
    id: number;
  }): Observable<InfrastructureResourcesRequestDto> {

    return this.infrastructureRoutesGetAllRessourcesOfAgivenInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<InfrastructureResourcesRequestDto>) => r.body as InfrastructureResourcesRequestDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure
   */
  static readonly InfrastructureRoutesGetAllSubInfasOfAGivenInfrastructurePath = '/infrastructure/{id}/subInfrastructures';

  /**
   * get all sub infrastructures of a given infrastructure
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure$Response(params: {

    /**
     * : infrastructure id
     */
    id: number;
  }): Observable<StrictHttpResponse<SubInfraListRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetAllSubInfasOfAGivenInfrastructurePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SubInfraListRequestDto>;
      })
    );
  }

  /**
   * get all sub infrastructures of a given infrastructure
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure(params: {

    /**
     * : infrastructure id
     */
    id: number;
  }): Observable<SubInfraListRequestDto> {

    return this.infrastructureRoutesGetAllSubInfasOfAGivenInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<SubInfraListRequestDto>) => r.body as SubInfraListRequestDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetById
   */
  static readonly InfrastructureRoutesGetByIdPath = '/infrastructure/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.infrastructureRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation infrastructureRoutesGetAll
   */
  static readonly InfrastructureRoutesGetAllPath = '/infrastructure/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `infrastructureRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.InfrastructureRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `infrastructureRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  infrastructureRoutesGetAll(params?: {
  }): Observable<void> {

    return this.infrastructureRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation organizationRoutesGetOrganizationById
   */
  static readonly OrganizationRoutesGetOrganizationByIdPath = '/organization/{id}';

  /**
   * organization by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetOrganizationById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationById$Response(params: {

    /**
     * organization id
     */
    id: number;
  }): Observable<StrictHttpResponse<GetOrganizationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetOrganizationByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetOrganizationDto>;
      })
    );
  }

  /**
   * organization by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetOrganizationById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationById(params: {

    /**
     * organization id
     */
    id: number;
  }): Observable<GetOrganizationDto> {

    return this.organizationRoutesGetOrganizationById$Response(params).pipe(
      map((r: StrictHttpResponse<GetOrganizationDto>) => r.body as GetOrganizationDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdate
   */
  static readonly OrganizationRoutesUpdatePath = '/organization/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.organizationRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation organizationRoutesRemove
   */
  static readonly OrganizationRoutesRemovePath = '/organization/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.organizationRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation organizationRoutesCreateOrganization
   */
  static readonly OrganizationRoutesCreateOrganizationPath = '/organization/createOrganization';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesCreateOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganization$Response(params: {
    body: CreateOrganizationRo
  }): Observable<StrictHttpResponse<CreateOrganizationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesCreateOrganizationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateOrganizationDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesCreateOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganization(params: {
    body: CreateOrganizationRo
  }): Observable<CreateOrganizationDto> {

    return this.organizationRoutesCreateOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<CreateOrganizationDto>) => r.body as CreateOrganizationDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganization
   */
  static readonly OrganizationRoutesUpdateOrganizationPath = '/organization/updateOrganization/{id}';

  /**
   * Update an organization in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganization$Response(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * Should contain general data Organization
     */
    body: UpdateOrganizationRo
  }): Observable<StrictHttpResponse<UpdateOrganizationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationDto>;
      })
    );
  }

  /**
   * Update an organization in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganization(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * Should contain general data Organization
     */
    body: UpdateOrganizationRo
  }): Observable<UpdateOrganizationDto> {

    return this.organizationRoutesUpdateOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationDto>) => r.body as UpdateOrganizationDto)
    );
  }

  /**
   * Path part for operation organizationRoutesDeleteOrganization
   */
  static readonly OrganizationRoutesDeleteOrganizationPath = '/organization/delete/{id}';

  /**
   * Delete an organization in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesDeleteOrganization()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesDeleteOrganization$Response(params: {

    /**
     * id of the delete organization
     */
    id: number;
    body: UpdateOrganizationRo
  }): Observable<StrictHttpResponse<OrganizationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesDeleteOrganizationPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizationDto>;
      })
    );
  }

  /**
   * Delete an organization in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesDeleteOrganization$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesDeleteOrganization(params: {

    /**
     * id of the delete organization
     */
    id: number;
    body: UpdateOrganizationRo
  }): Observable<OrganizationDto> {

    return this.organizationRoutesDeleteOrganization$Response(params).pipe(
      map((r: StrictHttpResponse<OrganizationDto>) => r.body as OrganizationDto)
    );
  }

  /**
   * Path part for operation organizationRoutesCreateOrganizationPhone
   */
  static readonly OrganizationRoutesCreateOrganizationPhonePath = '/organization/phone/{id}';

  /**
   * add an phone to a given organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesCreateOrganizationPhone()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganizationPhone$Response(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * Should contain new organization phone details
     */
    body: PhoneRo
  }): Observable<StrictHttpResponse<PhoneDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesCreateOrganizationPhonePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PhoneDto>;
      })
    );
  }

  /**
   * add an phone to a given organization
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesCreateOrganizationPhone$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganizationPhone(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * Should contain new organization phone details
     */
    body: PhoneRo
  }): Observable<PhoneDto> {

    return this.organizationRoutesCreateOrganizationPhone$Response(params).pipe(
      map((r: StrictHttpResponse<PhoneDto>) => r.body as PhoneDto)
    );
  }

  /**
   * Path part for operation organizationRoutesCreateOrganizationAdress
   */
  static readonly OrganizationRoutesCreateOrganizationAdressPath = '/organization/address/{id}';

  /**
   * create a new organization address in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesCreateOrganizationAdress()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganizationAdress$Response(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * add phone to organization as a name
     */
    body: AddressRo
  }): Observable<StrictHttpResponse<AddressBaseDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesCreateOrganizationAdressPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<AddressBaseDto>;
      })
    );
  }

  /**
   * create a new organization address in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesCreateOrganizationAdress$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesCreateOrganizationAdress(params: {

    /**
     * id of the updated organization
     */
    id: number;

    /**
     * add phone to organization as a name
     */
    body: AddressRo
  }): Observable<AddressBaseDto> {

    return this.organizationRoutesCreateOrganizationAdress$Response(params).pipe(
      map((r: StrictHttpResponse<AddressBaseDto>) => r.body as AddressBaseDto)
    );
  }

  /**
   * Path part for operation organizationRoutesGetUsers
   */
  static readonly OrganizationRoutesGetUsersPath = '/organization/getMembers/{id}';

  /**
   * retrive users that belongs to an organization
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetUsers()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetUsers$Response(params: {
    id: number;

    /**
     * : queryParam to fetch accepted or pending members
     */
    status?: string;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<OrganizationMembersDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetUsersPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('status', params.status, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrganizationMembersDto>;
      })
    );
  }

  /**
   * retrive users that belongs to an organization
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetUsers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetUsers(params: {
    id: number;

    /**
     * : queryParam to fetch accepted or pending members
     */
    status?: string;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<OrganizationMembersDto> {

    return this.organizationRoutesGetUsers$Response(params).pipe(
      map((r: StrictHttpResponse<OrganizationMembersDto>) => r.body as OrganizationMembersDto)
    );
  }

  /**
   * Path part for operation organizationRoutesGetOrganizationSettings
   */
  static readonly OrganizationRoutesGetOrganizationSettingsPath = '/organization/settings/{organizationId}';

  /**
   * retrieve Organization settings by organization id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetOrganizationSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationSettings$Response(params: {

    /**
     * organization id
     */
    organizationId: number;
  }): Observable<StrictHttpResponse<GetOrganizationSettingsBodyDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetOrganizationSettingsPath, 'get');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetOrganizationSettingsBodyDto>;
      })
    );
  }

  /**
   * retrieve Organization settings by organization id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetOrganizationSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationSettings(params: {

    /**
     * organization id
     */
    organizationId: number;
  }): Observable<GetOrganizationSettingsBodyDto> {

    return this.organizationRoutesGetOrganizationSettings$Response(params).pipe(
      map((r: StrictHttpResponse<GetOrganizationSettingsBodyDto>) => r.body as GetOrganizationSettingsBodyDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganizationsSettingsnMembersProperties
   */
  static readonly OrganizationRoutesUpdateOrganizationsSettingsnMembersPropertiesPath = '/organization/settings/member/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganizationsSettingsnMembersProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnMembersProperties$Response(params: {
    organizationId: number;
    body: OrganizationMemberSettingsRo
  }): Observable<StrictHttpResponse<UpdateOrganizationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationsSettingsnMembersPropertiesPath, 'put');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationSettingsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganizationsSettingsnMembersProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnMembersProperties(params: {
    organizationId: number;
    body: OrganizationMemberSettingsRo
  }): Observable<UpdateOrganizationSettingsDto> {

    return this.organizationRoutesUpdateOrganizationsSettingsnMembersProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationSettingsDto>) => r.body as UpdateOrganizationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganizationsSettingsnReservationProperties
   */
  static readonly OrganizationRoutesUpdateOrganizationsSettingsnReservationPropertiesPath = '/organization/settings/reservation/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganizationsSettingsnReservationProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnReservationProperties$Response(params: {
    organizationId: number;
    body: OrganizationReservationSettingsRo
  }): Observable<StrictHttpResponse<UpdateOrganizationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationsSettingsnReservationPropertiesPath, 'put');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationSettingsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganizationsSettingsnReservationProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnReservationProperties(params: {
    organizationId: number;
    body: OrganizationReservationSettingsRo
  }): Observable<UpdateOrganizationSettingsDto> {

    return this.organizationRoutesUpdateOrganizationsSettingsnReservationProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationSettingsDto>) => r.body as UpdateOrganizationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties
   */
  static readonly OrganizationRoutesUpdateOrganizationsSettingsnInvoicesPropertiesPath = '/organization/settings/invoices/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties$Response(params: {
    organizationId: number;
    body: OrganizationInvoicesSettingsRo
  }): Observable<StrictHttpResponse<UpdateOrganizationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationsSettingsnInvoicesPropertiesPath, 'put');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationSettingsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties(params: {
    organizationId: number;
    body: OrganizationInvoicesSettingsRo
  }): Observable<UpdateOrganizationSettingsDto> {

    return this.organizationRoutesUpdateOrganizationsSettingsnInvoicesProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationSettingsDto>) => r.body as UpdateOrganizationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganizationsSettingsnAccessProperties
   */
  static readonly OrganizationRoutesUpdateOrganizationsSettingsnAccessPropertiesPath = '/organization/settings/access/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganizationsSettingsnAccessProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnAccessProperties$Response(params: {
    organizationId: number;
    body: OrganizationAccessSettingsRo
  }): Observable<StrictHttpResponse<UpdateOrganizationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationsSettingsnAccessPropertiesPath, 'put');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationSettingsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganizationsSettingsnAccessProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsSettingsnAccessProperties(params: {
    organizationId: number;
    body: OrganizationAccessSettingsRo
  }): Observable<UpdateOrganizationSettingsDto> {

    return this.organizationRoutesUpdateOrganizationsSettingsnAccessProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationSettingsDto>) => r.body as UpdateOrganizationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesUpdateOrganizationsLocalisationSettingsProperties
   */
  static readonly OrganizationRoutesUpdateOrganizationsLocalisationSettingsPropertiesPath = '/organization/settings/localisation/{organizationId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesUpdateOrganizationsLocalisationSettingsProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsLocalisationSettingsProperties$Response(params: {
    organizationId: number;
    body: OrganizationlocalisationSettingsRo
  }): Observable<StrictHttpResponse<UpdateOrganizationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesUpdateOrganizationsLocalisationSettingsPropertiesPath, 'put');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateOrganizationSettingsDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesUpdateOrganizationsLocalisationSettingsProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  organizationRoutesUpdateOrganizationsLocalisationSettingsProperties(params: {
    organizationId: number;
    body: OrganizationlocalisationSettingsRo
  }): Observable<UpdateOrganizationSettingsDto> {

    return this.organizationRoutesUpdateOrganizationsLocalisationSettingsProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateOrganizationSettingsDto>) => r.body as UpdateOrganizationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesGetOrganizationLocalisationSettingsById
   */
  static readonly OrganizationRoutesGetOrganizationLocalisationSettingsByIdPath = '/organization/localizationSettings/{organizationId}';

  /**
   * retrieve Organization localisation settings by organization id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetOrganizationLocalisationSettingsById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationLocalisationSettingsById$Response(params: {

    /**
     * organization id
     */
    organizationId: number;
  }): Observable<StrictHttpResponse<GetOrganizationLoclisationSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetOrganizationLocalisationSettingsByIdPath, 'get');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetOrganizationLoclisationSettingsDto>;
      })
    );
  }

  /**
   * retrieve Organization localisation settings by organization id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetOrganizationLocalisationSettingsById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetOrganizationLocalisationSettingsById(params: {

    /**
     * organization id
     */
    organizationId: number;
  }): Observable<GetOrganizationLoclisationSettingsDto> {

    return this.organizationRoutesGetOrganizationLocalisationSettingsById$Response(params).pipe(
      map((r: StrictHttpResponse<GetOrganizationLoclisationSettingsDto>) => r.body as GetOrganizationLoclisationSettingsDto)
    );
  }

  /**
   * Path part for operation organizationRoutesGetById
   */
  static readonly OrganizationRoutesGetByIdPath = '/organization/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.organizationRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation organizationRoutesGetAll
   */
  static readonly OrganizationRoutesGetAllPath = '/organization/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `organizationRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.OrganizationRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `organizationRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  organizationRoutesGetAll(params?: {
  }): Observable<void> {

    return this.organizationRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation permissionRoutesGetAllPermissions
   */
  static readonly PermissionRoutesGetAllPermissionsPath = '/permission/getAllPermissions';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesGetAllPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetAllPermissions$Response(params?: {
  }): Observable<StrictHttpResponse<PermissionGetAllDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesGetAllPermissionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PermissionGetAllDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesGetAllPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetAllPermissions(params?: {
  }): Observable<PermissionGetAllDto> {

    return this.permissionRoutesGetAllPermissions$Response(params).pipe(
      map((r: StrictHttpResponse<PermissionGetAllDto>) => r.body as PermissionGetAllDto)
    );
  }

  /**
   * Path part for operation permissionRoutesCreatePermission
   */
  static readonly PermissionRoutesCreatePermissionPath = '/permission/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesCreatePermission()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesCreatePermission$Response(params: {

    /**
     * Should contain the permission data
     */
    body: CreatePermissionRo
  }): Observable<StrictHttpResponse<CreatePermissionDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesCreatePermissionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatePermissionDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesCreatePermission$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesCreatePermission(params: {

    /**
     * Should contain the permission data
     */
    body: CreatePermissionRo
  }): Observable<CreatePermissionDto> {

    return this.permissionRoutesCreatePermission$Response(params).pipe(
      map((r: StrictHttpResponse<CreatePermissionDto>) => r.body as CreatePermissionDto)
    );
  }

  /**
   * Path part for operation permissionRoutesUpdatePermission
   */
  static readonly PermissionRoutesUpdatePermissionPath = '/permission/update/{id}';

  /**
   * update a permission in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesUpdatePermission()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesUpdatePermission$Response(params: {

    /**
     * of the permission data
     */
    id: number;

    /**
     * Should contain the permission data
     */
    body: UpdatePermissionRo
  }): Observable<StrictHttpResponse<UpdatePermissionDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesUpdatePermissionPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdatePermissionDto>;
      })
    );
  }

  /**
   * update a permission in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesUpdatePermission$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesUpdatePermission(params: {

    /**
     * of the permission data
     */
    id: number;

    /**
     * Should contain the permission data
     */
    body: UpdatePermissionRo
  }): Observable<UpdatePermissionDto> {

    return this.permissionRoutesUpdatePermission$Response(params).pipe(
      map((r: StrictHttpResponse<UpdatePermissionDto>) => r.body as UpdatePermissionDto)
    );
  }

  /**
   * Path part for operation permissionRoutesDeletePermission
   */
  static readonly PermissionRoutesDeletePermissionPath = '/permission/delete/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesDeletePermission()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesDeletePermission$Response(params: {

    /**
     * of the permission data
     */
    id: number;
  }): Observable<StrictHttpResponse<PermissionGetDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesDeletePermissionPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PermissionGetDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesDeletePermission$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesDeletePermission(params: {

    /**
     * of the permission data
     */
    id: number;
  }): Observable<PermissionGetDto> {

    return this.permissionRoutesDeletePermission$Response(params).pipe(
      map((r: StrictHttpResponse<PermissionGetDto>) => r.body as PermissionGetDto)
    );
  }

  /**
   * Path part for operation permissionRoutesGetById
   */
  static readonly PermissionRoutesGetByIdPath = '/permission/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.permissionRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation permissionRoutesGetAll
   */
  static readonly PermissionRoutesGetAllPath = '/permission/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesGetAll(params?: {
  }): Observable<void> {

    return this.permissionRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation permissionRoutesUpdate
   */
  static readonly PermissionRoutesUpdatePath = '/permission/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  permissionRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.permissionRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation permissionRoutesRemove
   */
  static readonly PermissionRoutesRemovePath = '/permission/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PermissionRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.permissionRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation phoneRoutesGetById
   */
  static readonly PhoneRoutesGetByIdPath = '/phone/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phoneRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PhoneRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `phoneRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.phoneRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation phoneRoutesGetAll
   */
  static readonly PhoneRoutesGetAllPath = '/phone/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phoneRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PhoneRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `phoneRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesGetAll(params?: {
  }): Observable<void> {

    return this.phoneRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation phoneRoutesUpdate
   */
  static readonly PhoneRoutesUpdatePath = '/phone/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phoneRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phoneRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PhoneRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `phoneRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  phoneRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.phoneRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation phoneRoutesRemove
   */
  static readonly PhoneRoutesRemovePath = '/phone/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `phoneRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.PhoneRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `phoneRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  phoneRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.phoneRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation projectRoutesGetOrganizationProjects
   */
  static readonly ProjectRoutesGetOrganizationProjectsPath = '/projects/getOrganizationProjects/{id}';

  /**
   * Retrieve organization projects
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetOrganizationProjects()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetOrganizationProjects$Response(params: {

    /**
     * of organization
     */
    id: number;
    page?: number;
    limit?: number;
  }): Observable<StrictHttpResponse<ProjectGetDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetOrganizationProjectsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectGetDto>;
      })
    );
  }

  /**
   * Retrieve organization projects
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetOrganizationProjects$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetOrganizationProjects(params: {

    /**
     * of organization
     */
    id: number;
    page?: number;
    limit?: number;
  }): Observable<ProjectGetDto> {

    return this.projectRoutesGetOrganizationProjects$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectGetDto>) => r.body as ProjectGetDto)
    );
  }

  /**
   * Path part for operation projectRoutesGetOrganizationProjectById
   */
  static readonly ProjectRoutesGetOrganizationProjectByIdPath = '/projects/getOrganizationProjectById/{id}';

  /**
   * Retrieve organization project by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetOrganizationProjectById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetOrganizationProjectById$Response(params: {

    /**
     * of project
     */
    id: number;
  }): Observable<StrictHttpResponse<GetProjectDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetOrganizationProjectByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetProjectDto>;
      })
    );
  }

  /**
   * Retrieve organization project by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetOrganizationProjectById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetOrganizationProjectById(params: {

    /**
     * of project
     */
    id: number;
  }): Observable<GetProjectDto> {

    return this.projectRoutesGetOrganizationProjectById$Response(params).pipe(
      map((r: StrictHttpResponse<GetProjectDto>) => r.body as GetProjectDto)
    );
  }

  /**
   * Path part for operation projectRoutesCreateProject
   */
  static readonly ProjectRoutesCreateProjectPath = '/projects/create';

  /**
   * Containing data related to the project to be saved in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesCreateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesCreateProject$Response(params: {

    /**
     * containing data related to the project to be saved in the database
     * Should container Project data
     */
    body: ProjectRo
  }): Observable<StrictHttpResponse<CreateProjectDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesCreateProjectPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateProjectDto>;
      })
    );
  }

  /**
   * Containing data related to the project to be saved in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesCreateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesCreateProject(params: {

    /**
     * containing data related to the project to be saved in the database
     * Should container Project data
     */
    body: ProjectRo
  }): Observable<CreateProjectDto> {

    return this.projectRoutesCreateProject$Response(params).pipe(
      map((r: StrictHttpResponse<CreateProjectDto>) => r.body as CreateProjectDto)
    );
  }

  /**
   * Path part for operation projectRoutesUpdateProject
   */
  static readonly ProjectRoutesUpdateProjectPath = '/projects/updateProject/{id}';

  /**
   * Update a project in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesUpdateProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdateProject$Response(params: {
    id: number;
    body: UpdateProjectRo
  }): Observable<StrictHttpResponse<UpdateProjectDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesUpdateProjectPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateProjectDto>;
      })
    );
  }

  /**
   * Update a project in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesUpdateProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdateProject(params: {
    id: number;
    body: UpdateProjectRo
  }): Observable<UpdateProjectDto> {

    return this.projectRoutesUpdateProject$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateProjectDto>) => r.body as UpdateProjectDto)
    );
  }

  /**
   * Path part for operation projectRoutesAddMembersToProject
   */
  static readonly ProjectRoutesAddMembersToProjectPath = '/projects/{id}/projectMembers/create';

  /**
   * Containing data related to the participants of project to be saved in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesAddMembersToProject()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesAddMembersToProject$Response(params: {

    /**
     * containing id of the project want to add members too
     * Should container Project data
     */
    id: number;

    /**
     * containing array of data related to participants to be saved in the database
     */
    body: ProjectMemberRo
  }): Observable<StrictHttpResponse<CreateProjectMemberDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesAddMembersToProjectPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateProjectMemberDto>;
      })
    );
  }

  /**
   * Containing data related to the participants of project to be saved in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesAddMembersToProject$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesAddMembersToProject(params: {

    /**
     * containing id of the project want to add members too
     * Should container Project data
     */
    id: number;

    /**
     * containing array of data related to participants to be saved in the database
     */
    body: ProjectMemberRo
  }): Observable<CreateProjectMemberDto> {

    return this.projectRoutesAddMembersToProject$Response(params).pipe(
      map((r: StrictHttpResponse<CreateProjectMemberDto>) => r.body as CreateProjectMemberDto)
    );
  }

  /**
   * Path part for operation projectRoutesGetAllProjectParticipants
   */
  static readonly ProjectRoutesGetAllProjectParticipantsPath = '/projects/getParticipant/{id}';

  /**
   * retrive all participants working on project
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetAllProjectParticipants()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAllProjectParticipants$Response(params: {

    /**
     * : project id
     */
    id: number;
    page?: number;
    limit?: number;
  }): Observable<StrictHttpResponse<ProjectMemberRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetAllProjectParticipantsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectMemberRequestDto>;
      })
    );
  }

  /**
   * retrive all participants working on project
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetAllProjectParticipants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAllProjectParticipants(params: {

    /**
     * : project id
     */
    id: number;
    page?: number;
    limit?: number;
  }): Observable<ProjectMemberRequestDto> {

    return this.projectRoutesGetAllProjectParticipants$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectMemberRequestDto>) => r.body as ProjectMemberRequestDto)
    );
  }

  /**
   * Path part for operation projectRoutesUpdateRoleAndStatusOfProjectParticipant
   */
  static readonly ProjectRoutesUpdateRoleAndStatusOfProjectParticipantPath = '/projects/update/projectParticipant/{projectId}';

  /**
   * Update a project participant role and status in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesUpdateRoleAndStatusOfProjectParticipant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdateRoleAndStatusOfProjectParticipant$Response(params: {

    /**
     * project id
     */
    projectId: number;
    body: UpdateProjectParticipantRo
  }): Observable<StrictHttpResponse<UpdateProjectMemberDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesUpdateRoleAndStatusOfProjectParticipantPath, 'put');
    if (params) {
      rb.path('projectId', params.projectId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateProjectMemberDto>;
      })
    );
  }

  /**
   * Update a project participant role and status in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesUpdateRoleAndStatusOfProjectParticipant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdateRoleAndStatusOfProjectParticipant(params: {

    /**
     * project id
     */
    projectId: number;
    body: UpdateProjectParticipantRo
  }): Observable<UpdateProjectMemberDto> {

    return this.projectRoutesUpdateRoleAndStatusOfProjectParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateProjectMemberDto>) => r.body as UpdateProjectMemberDto)
    );
  }

  /**
   * Path part for operation projectRoutesGetAllOrganizationProjectsList
   */
  static readonly ProjectRoutesGetAllOrganizationProjectsListPath = '/projects/getProjectList/{id}';

  /**
   * this route is for the project list in frontend, it combine between Project and projectMember model
   * and send only the necessary data to print
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetAllOrganizationProjectsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAllOrganizationProjectsList$Response(params: {

    /**
     * : org id
     */
    id: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<ProjectListRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetAllOrganizationProjectsListPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProjectListRequestDto>;
      })
    );
  }

  /**
   * this route is for the project list in frontend, it combine between Project and projectMember model
   * and send only the necessary data to print
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetAllOrganizationProjectsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAllOrganizationProjectsList(params: {

    /**
     * : org id
     */
    id: number;

    /**
     * : queryParam to specify page the client want
     */
    page?: number;

    /**
     * : queryParam to specify the size of one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<ProjectListRequestDto> {

    return this.projectRoutesGetAllOrganizationProjectsList$Response(params).pipe(
      map((r: StrictHttpResponse<ProjectListRequestDto>) => r.body as ProjectListRequestDto)
    );
  }

  /**
   * Path part for operation projectRoutesGetById
   */
  static readonly ProjectRoutesGetByIdPath = '/projects/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.projectRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation projectRoutesGetAll
   */
  static readonly ProjectRoutesGetAllPath = '/projects/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesGetAll(params?: {
  }): Observable<void> {

    return this.projectRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation projectRoutesUpdate
   */
  static readonly ProjectRoutesUpdatePath = '/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  projectRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.projectRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation projectRoutesRemove
   */
  static readonly ProjectRoutesRemovePath = '/projects/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ProjectRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `projectRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.projectRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation reservationRoutesGetEventsByRange
   */
  static readonly ReservationRoutesGetEventsByRangePath = '/reservation/getEventsByRange/{resourceId}';

  /**
   * get all reservations within a given date range
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesGetEventsByRange()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetEventsByRange$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    start: string;
    end: string;
  }): Observable<StrictHttpResponse<ReservationsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesGetEventsByRangePath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.query('start', params.start, {});
      rb.query('end', params.end, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservationsDto>;
      })
    );
  }

  /**
   * get all reservations within a given date range
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesGetEventsByRange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetEventsByRange(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    start: string;
    end: string;
  }): Observable<ReservationsDto> {

    return this.reservationRoutesGetEventsByRange$Response(params).pipe(
      map((r: StrictHttpResponse<ReservationsDto>) => r.body as ReservationsDto)
    );
  }

  /**
   * Path part for operation reservationRoutesCreateReservation
   */
  static readonly ReservationRoutesCreateReservationPath = '/reservation/{resourceId}';

  /**
   * Create a reservation by resource Id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesCreateReservation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationRoutesCreateReservation$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    body: ReservationRo
  }): Observable<StrictHttpResponse<ReservationCreateDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesCreateReservationPath, 'post');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservationCreateDto>;
      })
    );
  }

  /**
   * Create a reservation by resource Id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesCreateReservation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationRoutesCreateReservation(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    body: ReservationRo
  }): Observable<ReservationCreateDto> {

    return this.reservationRoutesCreateReservation$Response(params).pipe(
      map((r: StrictHttpResponse<ReservationCreateDto>) => r.body as ReservationCreateDto)
    );
  }

  /**
   * Path part for operation reservationRoutesGetById
   */
  static readonly ReservationRoutesGetByIdPath = '/reservation/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.reservationRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation reservationRoutesGetAll
   */
  static readonly ReservationRoutesGetAllPath = '/reservation/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesGetAll(params?: {
  }): Observable<void> {

    return this.reservationRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation reservationRoutesUpdate
   */
  static readonly ReservationRoutesUpdatePath = '/reservation/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservationRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.reservationRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation reservationRoutesRemove
   */
  static readonly ReservationRoutesRemovePath = '/reservation/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservationRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ReservationRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservationRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  reservationRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.reservationRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation resourceRoutesCreateResource
   */
  static readonly ResourceRoutesCreateResourcePath = '/resources/create';

  /**
   * Registers a new resource in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesCreateResource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateResource$Response(params: {

    /**
     * Should contain Resource data that include Resource data
     */
    body: ResourceRo
  }): Observable<StrictHttpResponse<CreateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesCreateResourcePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateResourceDto>;
      })
    );
  }

  /**
   * Registers a new resource in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesCreateResource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateResource(params: {

    /**
     * Should contain Resource data that include Resource data
     */
    body: ResourceRo
  }): Observable<CreateResourceDto> {

    return this.resourceRoutesCreateResource$Response(params).pipe(
      map((r: StrictHttpResponse<CreateResourceDto>) => r.body as CreateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResource
   */
  static readonly ResourceRoutesUpdateResourcePath = '/resources/update/{id}';

  /**
   * Update a resource in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResource()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResource$Response(params: {

    /**
     * id of the requested resource
     */
    id: number;

    /**
     * Should contain Resource data that include Resource data with its id
     */
    body: UpdateResourceRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResource$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResource(params: {

    /**
     * id of the requested resource
     */
    id: number;

    /**
     * Should contain Resource data that include Resource data with its id
     */
    body: UpdateResourceRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResource$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetResourceById
   */
  static readonly ResourceRoutesGetResourceByIdPath = '/resources/getResourceById/{resourceId}';

  /**
   * get one resource by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetResourceById()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceById$Response(params: {

    /**
     * resource id
     */
    resourceId: number;
  }): Observable<StrictHttpResponse<ResourceGetDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetResourceByIdPath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResourceGetDto>;
      })
    );
  }

  /**
   * get one resource by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetResourceById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceById(params: {

    /**
     * resource id
     */
    resourceId: number;
  }): Observable<ResourceGetDto> {

    return this.resourceRoutesGetResourceById$Response(params).pipe(
      map((r: StrictHttpResponse<ResourceGetDto>) => r.body as ResourceGetDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetOrganizationResources
   */
  static readonly ResourceRoutesGetOrganizationResourcesPath = '/resources/getOrganizationResourcesById/{organizationId}';

  /**
   * retrieve all resources of a given organization by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetOrganizationResources()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetOrganizationResources$Response(params: {

    /**
     * organization id
     */
    organizationId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<StrictHttpResponse<GetResourcesBodyDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetOrganizationResourcesPath, 'get');
    if (params) {
      rb.path('organizationId', params.organizationId, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetResourcesBodyDto>;
      })
    );
  }

  /**
   * retrieve all resources of a given organization by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetOrganizationResources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetOrganizationResources(params: {

    /**
     * organization id
     */
    organizationId: number;

    /**
     * displayed page
     */
    page?: number;

    /**
     * number of item to display in one page
     */
    size?: number;

    /**
     * of type string used to do the search
     */
    query?: string;
  }): Observable<GetResourcesBodyDto> {

    return this.resourceRoutesGetOrganizationResources$Response(params).pipe(
      map((r: StrictHttpResponse<GetResourcesBodyDto>) => r.body as GetResourcesBodyDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetAllLoanableResources
   */
  static readonly ResourceRoutesGetAllLoanableResourcesPath = '/resources/getAllLoanableResources';

  /**
   * get loanable resources by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetAllLoanableResources()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAllLoanableResources$Response(params?: {
    category?: string;
    query?: string;
  }): Observable<StrictHttpResponse<ResourcesGetDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetAllLoanableResourcesPath, 'get');
    if (params) {
      rb.query('category', params.category, {});
      rb.query('query', params.query, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResourcesGetDto>;
      })
    );
  }

  /**
   * get loanable resources by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetAllLoanableResources$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAllLoanableResources(params?: {
    category?: string;
    query?: string;
  }): Observable<ResourcesGetDto> {

    return this.resourceRoutesGetAllLoanableResources$Response(params).pipe(
      map((r: StrictHttpResponse<ResourcesGetDto>) => r.body as ResourcesGetDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourcesSettingsReservationGeneral
   */
  static readonly ResourceRoutesUpdateResourcesSettingsReservationGeneralPath = '/resources/settings/reservation/general/{resourceId}';

  /**
   * Update a resource settings, section reservation general
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourcesSettingsReservationGeneral()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsReservationGeneral$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourcesSettingsReservationGeneralRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcesSettingsReservationGeneralPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource settings, section reservation general
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourcesSettingsReservationGeneral$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsReservationGeneral(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourcesSettingsReservationGeneralRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourcesSettingsReservationGeneral$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourcesSettingsGeneralStatus
   */
  static readonly ResourceRoutesUpdateResourcesSettingsGeneralStatusPath = '/resources/settings/general/status/{resourceId}';

  /**
   * Update a resource settings, section general status
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourcesSettingsGeneralStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsGeneralStatus$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceSettingsGeneralStatusRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcesSettingsGeneralStatusPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource settings, section general status
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourcesSettingsGeneralStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsGeneralStatus(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceSettingsGeneralStatusRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourcesSettingsGeneralStatus$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourcesSettingsReservationUnit
   */
  static readonly ResourceRoutesUpdateResourcesSettingsReservationUnitPath = '/resources/settings/reservation/unit/{resourceId}';

  /**
   * Update a resource settings, section reservation units
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourcesSettingsReservationUnit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsReservationUnit$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourcesSettingsReservationUnitRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcesSettingsReservationUnitPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource settings, section reservation units
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourcesSettingsReservationUnit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsReservationUnit(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourcesSettingsReservationUnitRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourcesSettingsReservationUnit$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourcesSettingsGeneralVisibility
   */
  static readonly ResourceRoutesUpdateResourcesSettingsGeneralVisibilityPath = '/resources/settings/general/visibility/{resourceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourcesSettingsGeneralVisibility()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsGeneralVisibility$Response(params: {
    resourceId: number;
    body: ResourceSettingsGeneralVisibilityRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcesSettingsGeneralVisibilityPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourcesSettingsGeneralVisibility$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsGeneralVisibility(params: {
    resourceId: number;
    body: ResourceSettingsGeneralVisibilityRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourcesSettingsGeneralVisibility$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetResourceRate
   */
  static readonly ResourceRoutesGetResourceRatePath = '/resources/settings/reservation/rate/{resourceId}';

  /**
   * get resource reservation rate
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetResourceRate()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceRate$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
  }): Observable<StrictHttpResponse<GetResourceRateDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetResourceRatePath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetResourceRateDto>;
      })
    );
  }

  /**
   * get resource reservation rate
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetResourceRate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceRate(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
  }): Observable<GetResourceRateDto> {

    return this.resourceRoutesGetResourceRate$Response(params).pipe(
      map((r: StrictHttpResponse<GetResourceRateDto>) => r.body as GetResourceRateDto)
    );
  }

  /**
   * Path part for operation resourceRoutesCreateResourceRate
   */
  static readonly ResourceRoutesCreateResourceRatePath = '/resources/settings/reservation/rate/{resourceId}';

  /**
   * Create a reservation rate
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesCreateResourceRate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateResourceRate$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceRateRo
  }): Observable<StrictHttpResponse<CreateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesCreateResourceRatePath, 'post');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreateResourceDto>;
      })
    );
  }

  /**
   * Create a reservation rate
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesCreateResourceRate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateResourceRate(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceRateRo
  }): Observable<CreateResourceDto> {

    return this.resourceRoutesCreateResourceRate$Response(params).pipe(
      map((r: StrictHttpResponse<CreateResourceDto>) => r.body as CreateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourceRate
   */
  static readonly ResourceRoutesUpdateResourceRatePath = '/resources/settings/reservation/rate/{resourceRateId}';

  /**
   * update reservation rate
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourceRate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceRate$Response(params: {
    resourceRateId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceRateRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourceRatePath, 'put');
    if (params) {
      rb.path('resourceRateId', params.resourceRateId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * update reservation rate
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourceRate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceRate(params: {
    resourceRateId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceRateRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourceRate$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourceTimerRestriction
   */
  static readonly ResourceRoutesUpdateResourceTimerRestrictionPath = '/resources/settings/reservation/time_restriction/{resourceId}';

  /**
   * Update a resource settings, section reservation time restriction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourceTimerRestriction()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceTimerRestriction$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceTimerRestrictionRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourceTimerRestrictionPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource settings, section reservation time restriction
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourceTimerRestriction$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceTimerRestriction(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceTimerRestrictionRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourceTimerRestriction$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourceRestrictionVisibility
   */
  static readonly ResourceRoutesUpdateResourceRestrictionVisibilityPath = '/resources/settings/reservation/visibility/{resourceId}';

  /**
   * Update a resource settings, section reservation time restriction
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourceRestrictionVisibility()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceRestrictionVisibility$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceReservationVisibilityRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourceRestrictionVisibilityPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * Update a resource settings, section reservation time restriction
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourceRestrictionVisibility$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourceRestrictionVisibility(params: {

    /**
     * Requested resource id
     */
    resourceId: number;

    /**
     * Should container resource settings data
     */
    body: ResourceReservationVisibilityRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourceRestrictionVisibility$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdateResourcesSettingsnGeneralProperties
   */
  static readonly ResourceRoutesUpdateResourcesSettingsnGeneralPropertiesPath = '/resources/settings/general/properties/{resourceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdateResourcesSettingsnGeneralProperties()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsnGeneralProperties$Response(params: {
    resourceId: number;
    body: ResourceSettingsGeneralPropertiesRo
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdateResourcesSettingsnGeneralPropertiesPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdateResourcesSettingsnGeneralProperties$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdateResourcesSettingsnGeneralProperties(params: {
    resourceId: number;
    body: ResourceSettingsGeneralPropertiesRo
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesUpdateResourcesSettingsnGeneralProperties$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetResourceSettings
   */
  static readonly ResourceRoutesGetResourceSettingsPath = '/resources/settings/{resourceId}';

  /**
   * Get a resource settings in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetResourceSettings()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceSettings$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
  }): Observable<StrictHttpResponse<GetResourceSettingsDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetResourceSettingsPath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetResourceSettingsDto>;
      })
    );
  }

  /**
   * Get a resource settings in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetResourceSettings$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetResourceSettings(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
  }): Observable<GetResourceSettingsDto> {

    return this.resourceRoutesGetResourceSettings$Response(params).pipe(
      map((r: StrictHttpResponse<GetResourceSettingsDto>) => r.body as GetResourceSettingsDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetEventsByRange
   */
  static readonly ResourceRoutesGetEventsByRangePath = '/resources/getEventsByRange/{resourceId}';

  /**
   * Get a resource settings in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetEventsByRange()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetEventsByRange$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    start: string;
    end: string;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetEventsByRangePath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.query('start', params.start, {});
      rb.query('end', params.end, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get a resource settings in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetEventsByRange$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetEventsByRange(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    start: string;
    end: string;
  }): Observable<{
}> {

    return this.resourceRoutesGetEventsByRange$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation resourceRoutesCreateReservation
   */
  static readonly ResourceRoutesCreateReservationPath = '/resources/createReservation/{resourceId}';

  /**
   * Get a resource settings in the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesCreateReservation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateReservation$Response(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesCreateReservationPath, 'post');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get a resource settings in the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesCreateReservation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesCreateReservation(params: {

    /**
     * Requested resource id
     */
    resourceId: number;
    body: {
}
  }): Observable<{
}> {

    return this.resourceRoutesCreateReservation$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation resourceRoutesAddResourceManager
   */
  static readonly ResourceRoutesAddResourceManagerPath = '/resources/{resourceId}/managers/{managerId}';

  /**
   * update a resource managers
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesAddResourceManager()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesAddResourceManager$Response(params: {

    /**
     * id of the target resource
     */
    resourceId: number;

    /**
     * id of the added manager
     */
    managerId: number;
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesAddResourceManagerPath, 'put');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.path('managerId', params.managerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * update a resource managers
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesAddResourceManager$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesAddResourceManager(params: {

    /**
     * id of the target resource
     */
    resourceId: number;

    /**
     * id of the added manager
     */
    managerId: number;
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesAddResourceManager$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesDeleteResourceManager
   */
  static readonly ResourceRoutesDeleteResourceManagerPath = '/resources/{resourceId}/managers/{managerId}';

  /**
   * delete a resource manager
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesDeleteResourceManager()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesDeleteResourceManager$Response(params: {

    /**
     * the target resource
     */
    resourceId: number;

    /**
     * id of the manager
     */
    managerId: number;
  }): Observable<StrictHttpResponse<UpdateResourceDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesDeleteResourceManagerPath, 'delete');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
      rb.path('managerId', params.managerId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UpdateResourceDto>;
      })
    );
  }

  /**
   * delete a resource manager
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesDeleteResourceManager$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesDeleteResourceManager(params: {

    /**
     * the target resource
     */
    resourceId: number;

    /**
     * id of the manager
     */
    managerId: number;
  }): Observable<UpdateResourceDto> {

    return this.resourceRoutesDeleteResourceManager$Response(params).pipe(
      map((r: StrictHttpResponse<UpdateResourceDto>) => r.body as UpdateResourceDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetAllRessourcesOfAgivenInfrastructure
   */
  static readonly ResourceRoutesGetAllRessourcesOfAgivenInfrastructurePath = '/resources/{resourceId}/managers';

  /**
   * get all managers of a given resource
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetAllRessourcesOfAgivenInfrastructure()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAllRessourcesOfAgivenInfrastructure$Response(params: {

    /**
     * : resource id
     */
    resourceId: number;
  }): Observable<StrictHttpResponse<ResourceManagersRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetAllRessourcesOfAgivenInfrastructurePath, 'get');
    if (params) {
      rb.path('resourceId', params.resourceId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResourceManagersRequestDto>;
      })
    );
  }

  /**
   * get all managers of a given resource
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetAllRessourcesOfAgivenInfrastructure$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAllRessourcesOfAgivenInfrastructure(params: {

    /**
     * : resource id
     */
    resourceId: number;
  }): Observable<ResourceManagersRequestDto> {

    return this.resourceRoutesGetAllRessourcesOfAgivenInfrastructure$Response(params).pipe(
      map((r: StrictHttpResponse<ResourceManagersRequestDto>) => r.body as ResourceManagersRequestDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetById
   */
  static readonly ResourceRoutesGetByIdPath = '/resources/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.resourceRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation resourceRoutesGetAll
   */
  static readonly ResourceRoutesGetAllPath = '/resources/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesGetAll(params?: {
  }): Observable<void> {

    return this.resourceRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation resourceRoutesUpdate
   */
  static readonly ResourceRoutesUpdatePath = '/resources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  resourceRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.resourceRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation resourceRoutesRemove
   */
  static readonly ResourceRoutesRemovePath = '/resources/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resourceRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.ResourceRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `resourceRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resourceRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.resourceRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation userRoutesRegisterUserFromToken
   */
  static readonly UserRoutesRegisterUserFromTokenPath = '/users/registerUserFromToken';

  /**
   * Registers a new user in the database
   * this route is called after signup
   * since keycloak takes care of creating the user
   * we parse the user data from the keycloak token
   * and save it to the database
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesRegisterUserFromToken()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesRegisterUserFromToken$Response(params?: {
  }): Observable<StrictHttpResponse<RegisterUserFromTokenDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesRegisterUserFromTokenPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RegisterUserFromTokenDto>;
      })
    );
  }

  /**
   * Registers a new user in the database
   * this route is called after signup
   * since keycloak takes care of creating the user
   * we parse the user data from the keycloak token
   * and save it to the database
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesRegisterUserFromToken$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesRegisterUserFromToken(params?: {
  }): Observable<RegisterUserFromTokenDto> {

    return this.userRoutesRegisterUserFromToken$Response(params).pipe(
      map((r: StrictHttpResponse<RegisterUserFromTokenDto>) => r.body as RegisterUserFromTokenDto)
    );
  }

  /**
   * Path part for operation userRoutesResetPassword
   */
  static readonly UserRoutesResetPasswordPath = '/users/resetPassword';

  /**
   * Method that resets a user password in keycloak
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesResetPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesResetPassword$Response(params: {
    body: ResetPasswordRo
  }): Observable<StrictHttpResponse<ResetPasswordDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesResetPasswordPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ResetPasswordDto>;
      })
    );
  }

  /**
   * Method that resets a user password in keycloak
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesResetPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesResetPassword(params: {
    body: ResetPasswordRo
  }): Observable<ResetPasswordDto> {

    return this.userRoutesResetPassword$Response(params).pipe(
      map((r: StrictHttpResponse<ResetPasswordDto>) => r.body as ResetPasswordDto)
    );
  }

  /**
   * Path part for operation userRoutesCreateUser
   */
  static readonly UserRoutesCreateUserPath = '/users/create';

  /**
   * Create user
   * Must be authentificated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesCreateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesCreateUser$Response(params: {

    /**
     * : User object
     */
    body: UserRo
  }): Observable<StrictHttpResponse<CreatedUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesCreateUserPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatedUserDto>;
      })
    );
  }

  /**
   * Create user
   * Must be authentificated
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesCreateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesCreateUser(params: {

    /**
     * : User object
     */
    body: UserRo
  }): Observable<CreatedUserDto> {

    return this.userRoutesCreateUser$Response(params).pipe(
      map((r: StrictHttpResponse<CreatedUserDto>) => r.body as CreatedUserDto)
    );
  }

  /**
   * Path part for operation userRoutesUpdateUser
   */
  static readonly UserRoutesUpdateUserPath = '/users/updateUser/{keycloakId}';

  /**
   * update user
   * Must be authentificated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesUpdateUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdateUser$Response(params: {
    keycloakId: string;

    /**
     * : User object
     */
    body: UserRo
  }): Observable<StrictHttpResponse<CreatedUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesUpdateUserPath, 'put');
    if (params) {
      rb.path('keycloakId', params.keycloakId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatedUserDto>;
      })
    );
  }

  /**
   * update user
   * Must be authentificated
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesUpdateUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdateUser(params: {
    keycloakId: string;

    /**
     * : User object
     */
    body: UserRo
  }): Observable<CreatedUserDto> {

    return this.userRoutesUpdateUser$Response(params).pipe(
      map((r: StrictHttpResponse<CreatedUserDto>) => r.body as CreatedUserDto)
    );
  }

  /**
   * Path part for operation userRoutesUpdateUserDetails
   */
  static readonly UserRoutesUpdateUserDetailsPath = '/users/updateUserDetail/{userId}';

  /**
   * Update user details
   * Must be authentificated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesUpdateUserDetails()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdateUserDetails$Response(params: {
    userId: number;

    /**
     * : User object
     */
    body: UserRo
  }): Observable<StrictHttpResponse<CreatedUserDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesUpdateUserDetailsPath, 'put');
    if (params) {
      rb.path('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CreatedUserDto>;
      })
    );
  }

  /**
   * Update user details
   * Must be authentificated
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesUpdateUserDetails$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdateUserDetails(params: {
    userId: number;

    /**
     * : User object
     */
    body: UserRo
  }): Observable<CreatedUserDto> {

    return this.userRoutesUpdateUserDetails$Response(params).pipe(
      map((r: StrictHttpResponse<CreatedUserDto>) => r.body as CreatedUserDto)
    );
  }

  /**
   * Path part for operation userRoutesGetUserByKeycloakId
   */
  static readonly UserRoutesGetUserByKeycloakIdPath = '/users/getUserByKeycloakId';

  /**
   * Get user By auth token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesGetUserByKeycloakId()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetUserByKeycloakId$Response(params?: {
  }): Observable<StrictHttpResponse<UserGetDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesGetUserByKeycloakIdPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<UserGetDto>;
      })
    );
  }

  /**
   * Get user By auth token
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesGetUserByKeycloakId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetUserByKeycloakId(params?: {
  }): Observable<UserGetDto> {

    return this.userRoutesGetUserByKeycloakId$Response(params).pipe(
      map((r: StrictHttpResponse<UserGetDto>) => r.body as UserGetDto)
    );
  }

  /**
   * Path part for operation userRoutesChangeUserLanguage
   */
  static readonly UserRoutesChangeUserLanguagePath = '/users/internationalization/{language}';

  /**
   * update user  language
   * Must be authentificated
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesChangeUserLanguage()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesChangeUserLanguage$Response(params: {

    /**
     * : User  language
     */
    language: string;
  }): Observable<StrictHttpResponse<ChangeUserLanguageDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesChangeUserLanguagePath, 'put');
    if (params) {
      rb.path('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ChangeUserLanguageDto>;
      })
    );
  }

  /**
   * update user  language
   * Must be authentificated
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesChangeUserLanguage$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesChangeUserLanguage(params: {

    /**
     * : User  language
     */
    language: string;
  }): Observable<ChangeUserLanguageDto> {

    return this.userRoutesChangeUserLanguage$Response(params).pipe(
      map((r: StrictHttpResponse<ChangeUserLanguageDto>) => r.body as ChangeUserLanguageDto)
    );
  }

  /**
   * Path part for operation userRoutesGetById
   */
  static readonly UserRoutesGetByIdPath = '/users/getById/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesGetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetById$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<BaseRequestDto>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesGetByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BaseRequestDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesGetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetById(params: {
    id: number;
  }): Observable<BaseRequestDto> {

    return this.userRoutesGetById$Response(params).pipe(
      map((r: StrictHttpResponse<BaseRequestDto>) => r.body as BaseRequestDto)
    );
  }

  /**
   * Path part for operation userRoutesGetAll
   */
  static readonly UserRoutesGetAllPath = '/users/getAll';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesGetAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetAll$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesGetAllPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesGetAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesGetAll(params?: {
  }): Observable<void> {

    return this.userRoutesGetAll$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation userRoutesUpdate
   */
  static readonly UserRoutesUpdatePath = '/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdate$Response(params: {
    id: number;
    body: {
}
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  userRoutesUpdate(params: {
    id: number;
    body: {
}
  }): Observable<{
}> {

    return this.userRoutesUpdate$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

  /**
   * Path part for operation userRoutesRemove
   */
  static readonly UserRoutesRemovePath = '/users/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `userRoutesRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesRemove$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<{
}>> {

    const rb = new RequestBuilder(this.rootUrl, ApiService.UserRoutesRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `userRoutesRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  userRoutesRemove(params: {
    id: number;
  }): Observable<{
}> {

    return this.userRoutesRemove$Response(params).pipe(
      map((r: StrictHttpResponse<{
}>) => r.body as {
})
    );
  }

}
